import { useState } from 'react'
import { PieImage } from 'components/common'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface TimeFrameWarningModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	avatarUrl?: string
	coverAvatarUrl?: string
	onChangeStartTime?: () => void
}

export function TimeFrameWarningModal({
	open,
	setOpen,
	avatarUrl,
	coverAvatarUrl,
	onChangeStartTime,
}: TimeFrameWarningModalProps) {
	const handleChangeStartTime = () => {
		setOpen(false)
		onChangeStartTime?.()
	}

	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			className="sm:!px-9"
			customSize="sm:max-w-[341px]"
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div>
					<div>
						<h3 className="text-2xl font-medium mb-5 flex justify-center items-center gap-2">Oops...</h3>
						<div className="max-w-[269px] mx-auto">
							Looks like you have not completed your reward before the start time.
						</div>
					</div>
					<div className="flex justify-center items-center py-8">
						<PieImage
							className="w-[200px] h-auto rounded-xl overflow-hidden flex-shrink-0"
							images={[avatarUrl || coverAvatarUrl || '']}
						/>
					</div>
					<div className="max-w-[208px] mx-auto">
						Please set your start time on your reward to a future time.
					</div>
					<div className="mt-8 mb-6">
						<button
							type="button"
							className="px-6 rounded-3xl transition-all duration-300 bg-primary h-12 hover:bg-primary-hover disabled:bg-white-25 disabled:text-white-25 disabled:backdrop-blur-lg w-full font-bold"
							onClick={handleChangeStartTime}
						>
							Change Start Time
						</button>
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface TimeFrameWarningModalManagedProps {
	avatarUrl?: string
	coverAvatarUrl?: string
	onChangeStartTime?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'time-frame-warning': TimeFrameWarningModalManagedProps
	}
}

export function ManagedTimeFrameWarningModal({
	onClose,
	onChangeStartTime,
	...rest
}: TimeFrameWarningModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<TimeFrameWarningModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onChangeStartTime={() => { onChangeStartTime?.(); handleClose() }}
			{...rest}
		/>
	)
}
